import { render, staticRenderFns } from "./addPhoto.vue?vue&type=template&id=1cc0b960&"
import script from "./addPhoto.vue?vue&type=script&lang=js&"
export * from "./addPhoto.vue?vue&type=script&lang=js&"
import style0 from "./addPhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
